import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { SivaInnovationFundsOverviewDto } from 'src/api/v2';
import { formatCurrencySimple } from 'src/utils/FormatValue';

export const useFundsOverviewColumns = () => {
  const columnHelper = createColumnHelper<SivaInnovationFundsOverviewDto>();

  return [
    columnHelper.accessor((row) => row.typeOfCompany, {
      id: 'type',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor((row) => row.clusterName, {
      id: 'name',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor((row) => row.sumPreIncubation, {
      id: 'preInkFunds',
      cell: (info) => {
        const value = info.getValue();
        return value ? formatCurrencySimple(value) : '';
      },
    }),
    columnHelper.accessor((row) => row.sumOtherPhases, {
      id: 'otherFunds',
      cell: (info) => {
        const value = info.getValue();
        return value ? formatCurrencySimple(value) : '';
      },
    }),
    columnHelper.accessor((row) => (row.sumOtherPhases || 0) + (row.sumPreIncubation || 0), {
      id: 'totalFunds',
      cell: (info) => {
        const value = info.getValue();
        return value ? formatCurrencySimple(value) : '';
      },
    }),
    columnHelper.accessor((row) => row.clusterId, {
      id: '__details',
      cell: (info) => (
        <Link className="text-color--black" to={info.getValue()}>
          Se detaljer
        </Link>
      ),
      enableSorting: false,
      enableColumnFilter: false,
      enableGlobalFilter: false,
      header: '',
    }),
  ];
};
